module.exports = __webpack_public_path__ + "static/media/2005.f087ac45.png";